export * as Api from './api';
export var TrancheVisibility;
(function (TrancheVisibility) {
    TrancheVisibility["ShowOnTranche"] = "tranche";
    TrancheVisibility["ShowOnFirm"] = "firm";
})(TrancheVisibility || (TrancheVisibility = {}));
export var FundStatus;
(function (FundStatus) {
    FundStatus[FundStatus["Closed"] = 0] = "Closed";
    FundStatus[FundStatus["Open"] = 1] = "Open";
    FundStatus[FundStatus["Draft"] = 2] = "Draft";
})(FundStatus || (FundStatus = {}));
//# sourceMappingURL=index.js.map